import React from 'react';
import { observer, Observer, inject } from 'mobx-react';
import { toJS, action } from 'mobx';
import moment from 'moment';
import * as constants from '../../model/const';

import { SvgImg } from '../component/SvgImg';
import { SiteHeader } from '../component/SiteHeader';
import { SiteFooter } from '../component/SiteFooter';

import { BWStepBar } from '../component/BWStepBar';
import { BWReceipt } from '../component/BWReceipt';

import { fmtPrice, fmtPercent } from '../../model/formatters';
import translateBase from '../../translate';

let translate = translateBase.bindPage('bw06Payment');

@inject(stores => ({
  flasher: stores.app.flasher,
  navigation: stores.app.navigation,
  rentalTransaction: stores.app.rentalTransaction,
  vPayment: stores.app.vPayment,
  //rentalObject: stores.app.rentalObject,
  businessUnit: stores.app.businessUnit,
}))
@observer
export class BWPayment extends React.Component {
  refInputLink = (element) => {
    this.linkInput = element;
  }

  componentDidMount() {
    if (this.props.vPayment.errorMessage) {
      this.props.flasher.reportError('Error', this.props.vPayment.errorMessage)
    }
    if (this.props.vPayment.cancellationMessage) {
      this.props.flasher.reportError('Error', this.props.vPayment.cancellationMessage)
    }
  }

  render() {
    const { navigation, rentalTransaction, vPayment, businessUnit } = this.props;
    const currency = businessUnit.currencyName; //"CHF";
    return (
      <div>
        <SiteHeader />

        <BWStepBar activeStep={6} />

        {/*<BWReceipt /> */}


        <section className="wizard-container booking-view">
          <div className="wrapper">

            <div className="row wizard-content">
              <div className="column-12">
                <h3 className="mali-blue">{translate("payment", "Zahlung")}</h3>

                <div className="payment-container">
                  <div className="paymentType-container">
                    {businessUnit.paymentTypes.map(paymentType => {
                      if (paymentType.id === constants.PAYMENT_TYPE.UBERNAHME) {
                        return (
                          <div key={paymentType.id}
                            className={"paymentType-option" + (paymentType.id === vPayment.paymentType ? " selected" : "")}
                            onClick={event => vPayment.setPaymentType(paymentType.id)}>
                            <div className="paymentType-icon">
                            <SvgImg className="svg cash-icon" src="/clients/standard/release/assets/content/icons/cash.svg" />
                            </div>
                            <div className="paymentType-text">
                              <div className="paymentType-title">
                                {paymentType.name} {/*Bar bei Übernahme*/}
                              </div>
                              <div className="paymentType-explainText">
                                {paymentType.description}
                              </div>
                            </div>
                          </div>
                        )
                      }
                      if (paymentType.id === constants.PAYMENT_TYPE.BANKUBERWEISUNG) {
                        return (
                          <div key={paymentType.id}
                            className={"paymentType-option" + (paymentType.id === vPayment.paymentType ? " selected" : "")}
                            onClick={event => vPayment.setPaymentType(paymentType.id)}>
                            <div className="paymentType-icon">
                              <SvgImg className="svg bankTransfer-icon" src="/clients/standard/release/assets/content/icons/bank-transfer.svg" />
                            </div>
                            <div className="paymentType-text">
                              <div className="paymentType-title">
                                {paymentType.name} {/*Banküberweisung */}
                              </div>
                              <div className="paymentType-explainText">
                                {paymentType.description}
                              </div>
                            </div>
                          </div>
                        )
                      }
                      if (paymentType.id === constants.PAYMENT_TYPE.KREDITKARTENZAHLUNG) {
                        return (
                          <div key={paymentType.id}
                            className={"paymentType-option" + (paymentType.id === vPayment.paymentType ? " selected" : "")}
                            onClick={event => vPayment.setPaymentType(paymentType.id)}>
                            <div className="paymentType-icon">
                              <SvgImg className="svg creditCard-icon" src="/clients/standard/release/assets/content/icons/credit-card.svg" />
                            </div>
                            <div className="paymentType-text">
                              <div className="paymentType-title">
                                {paymentType.name} {/*Kreditkartenzahlung*/}
                              </div>
                              <div className="paymentType-explainText">
                                {paymentType.description}
                              </div>
                            </div>
                          </div>
                        )
                      }
                      if (paymentType.id === constants.PAYMENT_TYPE.PERIODISCHERECHNUNG) {
                        return (
                          <div key={paymentType.id}
                            className={"paymentType-option" + (paymentType.id === vPayment.paymentType ? " selected" : "")}
                            onClick={event => vPayment.setPaymentType(paymentType.id)}>
                            <div className="paymentType-icon">
                              <SvgImg className="svg periodicBill-icon" src="/clients/standard/release/assets/content/icons/periodic-bill.svg" />
                            </div>
                            <div className="paymentType-text">
                              <div className="paymentType-title">
                                {paymentType.name} {/*PeriodischeRechnung*/}
                              </div>
                              <div className="paymentType-explainText">
                                {paymentType.description}
                              </div>
                            </div>
                          </div>
                        )
                      }                      
                    })}
                    {
                      vPayment.customerPaymentMethods.map(paymentType => {
                        if (paymentType.refPaymentMethodId === constants.PAYMENT_TYPE.PERIODISCHERECHNUNG) {
                          return (
                            <div key={paymentType.refPaymentMethodId}
                              className={"paymentType-option" + (paymentType.refPaymentMethodId === vPayment.paymentType ? " selected" : "")}
                              onClick={event => vPayment.setPaymentType(paymentType.refPaymentMethodId)}>
                              <div className="paymentType-icon">
                                <SvgImg className="svg periodicBill-icon" src="/clients/standard/release/assets/content/icons/periodic-bill.svg" />
                              </div>
                              <div className="paymentType-text">
                                <div className="paymentType-title">
                                  {paymentType.Name}
                                </div>
                                <div className="paymentType-explainText">
                                  {paymentType.Description}
                                </div>
                              </div>
                            </div>
                          )
                        }
                      })
                    }
                  </div>
                  {vPayment.paymentType === constants.PAYMENT_TYPE.BANKUBERWEISUNG &&
                    <div className="payment-info">
                      <h4>{translate("bankAccount", "Bankverbindung")}</h4>
                      <div className="payment-account">
                        {businessUnit.bankAccountDescription}
                      </div>
                      <h4>{translate("bankPaymentConditions", "Zahlungsbedingungen")}</h4>
                      <div className="payment-conditions">
                        {businessUnit.bankAccountPaymentInstruction}
                      </div>
                    </div>
                  }
               </div>
              </div>
            </div>

            <div className="row main-wizardbtns-container">
              <div className="column-6">
                <a className="back" onClick={navigation.goBWReview}><i className="fa fa-arrow-left" aria-hidden="true"></i> {translate("back", "Zurück")}</a>
              </div>
              <div className="column-6">
                <a id="btn-fwd-bwpay" className="forward" onClick={vPayment.finishBooking}>{translate("firmlyBookFor", "Verbindlich Buchen für")} {currency} {fmtPrice(rentalTransaction.totalDiscountedPrice)} <i className="fa fa-check" aria-hidden="true"></i></a>
              </div>
            </div>

          </div>
        </section>

        <SiteFooter />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/visual/view/BWPayment.js